import { Box, For, Stack, StackSeparator, HStack, Text } from '@chakra-ui/react'
import sortBy from 'lodash/sortBy'
import { memo, useCallback, useMemo } from 'react'

import { Avatar } from '@app/components/ui/avatar'
import UserAccountsFetcher from '@app/fetchers/userAccountsFetcher'
import useGetObjectsByProperties from '@app/hooks/useGetObjectsByProperties'
import useStoreCurrentUser from '@app/hooks/useStoreCurrentUser'
import { abilitiesFor } from '@app/shared/authorization/caslProvider'
import AccountRailAccount from '@app/shared/layout/shells/components/accountRailAccount'
import OrganizationCreateButton from '@app/shared/organizations/organizationCreateButton'

const AccountRail = () => {
  const { user } = useStoreCurrentUser()

  const filter = useCallback((account) => account.userId === user.id && !account.disabledAt, [user.id])
  const userAccounts = useGetObjectsByProperties('account', filter)

  const sortedAccounts = useMemo(
    () => sortBy(userAccounts, (account) => account.organizationName.toLowerCase()),
    [userAccounts]
  )

  const abilities = useMemo(() => abilitiesFor(user), [user])
  const canCreateVendorOrganizations =
    abilities.can('create', 'vendorOrganizations') && abilities.can('update', 'organization')

  return (
    <Box w="full" h="full">
      <UserAccountsFetcher />
      <Stack
        direction="column"
        alignItems="stretch"
        alignContent="flex-start"
        overflow="hidden"
        h="100%"
        separator={<StackSeparator />}
        gap={0}
      >
        {canCreateVendorOrganizations && (
          <Box flex="0 1" px={6} textAlign="center" pb={4}>
            <OrganizationCreateButton>
              <HStack w="full" cursor="pointer" color="fg.muted" _hover={{ color: 'fg' }}>
                <Avatar shape="rounded" name="+" size="2xs" />
                <Text fontSize="sm">Add customer</Text>
              </HStack>
            </OrganizationCreateButton>
          </Box>
        )}
        <Stack gap={1} flex="1 0" overflow="auto" px={6} py={4}>
          <For each={sortedAccounts}>
            {(account) => <AccountRailAccount account={account} user={user} key={account.id} />}
          </For>
        </Stack>
      </Stack>
    </Box>
  )
}

export default memo(AccountRail)
